import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, OnDestroy {
  // Navigation state
  isMenuOpen = false;
  activeDropdown: string | null = null;
  isTransparent = true;

  private destroy$ = new Subject<void>();

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Subscribe to route changes to close menu and reset carousel
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.closeMenu();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Toggle mobile menu visibility
   */
  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  /**
   * Toggle dropdown menu
   * @param dropdownName Name of the dropdown to toggle
   * @param event Click event
   */
  toggleDropdown(dropdownName: string, event: Event): void {
    event.preventDefault();
    this.activeDropdown = this.activeDropdown === dropdownName ? null : dropdownName;
  }

  /**
   * Close menu and dropdowns
   */
  closeMenu(): void {
    this.isMenuOpen = false;
    this.activeDropdown = null;
  }



  /**
   * Listen for navbar transparency on scroll
   */
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isTransparent = offset < 100;
  }

  /**
   * Close dropdown when clicking outside
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const isClickInsideNav = target.closest('.navbar-nav') || target.closest('.navbar-toggler');
    if (!isClickInsideNav) {
      this.activeDropdown = null;
    }
  }
}
